import { Types } from '@store/types';

const initialState = [];

const ProjectManagerReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_PROJECT_MANAGER_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default ProjectManagerReducer;
